import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import TitleCommon from "../components/TitleCommon";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Nav,
  Row,
  Tab,
} from "react-bootstrap";
import { StyledTabs } from "../components/StyledCommon";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import Loader from "../components/Loader";
import ErrorMsg from "../components/ErrorMsg";
import ScrollRangeBoard from "../components/ScrollRangeBoard";
import SuperTableV2 from "../components/SuperTableV2";
import { Link } from "react-router-dom";
import emptyImg from "../assets/iso.png";
import { fetchBriefcases } from "../redux";
import { BriefcaseServices } from "../components/Briefcase/BriefcaseServices";

const Briefcase = () => {
  const [t] = useTranslation("briefcase");
  const dispatch = useDispatch();
  const briefcase = useSelector((state) => state.briefcase);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  useEffect(() => {
    dispatch(fetchBriefcases());
  }, [dispatch]);

  const deleteBriefcase = (uid) => {
    swal({
      title: t("briefcase_swal_delete_title"),
      text: t("briefcase_swal_delete_text"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirm) => {
      if (!confirm) return;
      try {
        await BriefcaseServices.remove(uid);
        swal(t("briefcase_modal_done_1"), t("briefcase_modal_done_4"), "success");
        dispatch(fetchBriefcases());
      } catch (error) {
        const status = error && error.response && error.response.status;
        if (status === 409) {
          swal("¡Ups!", t("briefcase_error_has_learnings_reused"), "error");
        } else {
          swal("¡Ups!", t("briefcase_modal_done_5"), "error");
        }
      }
    });
  };

  const columns = [
    {
      caption: t("briefcase_tablecolumn_name"),
      selector: "Nombre",
      width: 360,
      customRender: (row) => {
        const idPortafolio = row.data.IdPortafolio;
        return (
          <div className="d-flex align-items-center dropdown-in-table">
            <Dropdown
              onClick={(e) => e.stopPropagation()}
              show={openDropdownId === idPortafolio}
              onToggle={(nextShow) =>
                setOpenDropdownId(nextShow ? idPortafolio : null)
              }
            >
              <Dropdown.Toggle
                variant="outline-primary"
                size="sm"
                className="dropdown-btn-ellipsis"
              >
                <i className="fa fa-ellipsis-h"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu
                renderOnMount
                popperConfig={{ strategy: "fixed" }}
              >
                <Dropdown.Item as={Link} to={`/briefcase/${idPortafolio}`}>
                  {t("briefcase_btn_options_edit")}
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={`/briefcase/${idPortafolio}?tab=compromisos`}>
                  {t("briefcase_btn_options_compromisos")}
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={`/briefcase/${idPortafolio}?tab=aprendizajes`}>
                  {t("briefcase_btn_options_aprendizajes")}
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={`/briefcase/${idPortafolio}?tab=retrospectivas`}>
                  {t("briefcase_btn_options_retrospectivas")}
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={`/briefcase/${idPortafolio}?tab=retro-tablero`}>
                  {t("briefcase_btn_options_retro_tablero")}
                </Dropdown.Item>
                {/* "Ver informe" (Hoja de Vida / dashboard): oculto temporalmente a pedido de negocio (2026-06-18). Ruta y componente siguen existiendo. */}
                <Dropdown.Item onClick={() => deleteBriefcase(idPortafolio)}>
                  {t("briefcase_btn_options_delete")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <span
              className="ml-2"
              style={{ maxWidth: "300px" }}
              title={row.data.Nombre}
            >
              <Link to={`/briefcase/${idPortafolio}`}>{row.data.Nombre}</Link>
            </span>
          </div>
        );
      },
    },
    {
      caption: t("briefcase_tablecolumn_description"),
      selector: "Descripcion",
      width: 320,
    },
    {
      caption: t("briefcase_tablecolumn_created"),
      selector: "FechaCreado",
      width: 140,
    },
    {
      caption: t("briefcase_tablecolumn_projects"),
      selector: "TotalProyectos",
      align: "center",
      width: 140,
    },
  ];

  const briefcases = briefcase.briefcases || [];
  const hasBriefcases = briefcases.length > 0;

  return (
    <>
      <Layout>
        <TitleCommon
          title={{
            text: t("briefcase_title"),
            icon: "briefcase",
          }}
        />
        <Container fluid>
          <Tab.Container
            id="briefcase-tabs"
            defaultActiveKey="first"
            transition={false}
          >
            <Row className="bg-light">
              <Col>
                <StyledTabs as={Nav}>
                  <Nav.Item>
                    <Nav.Link eventKey="first">
                      {t("briefcase_button_inprogress")}
                    </Nav.Link>
                  </Nav.Item>
                </StyledTabs>
              </Col>
            </Row>
            <Row>
              <Col className="pt-3 pb-5 mb-5">
                <Tab.Content>
                  <Tab.Pane
                    eventKey="first"
                    className="animate__animated animate__fadeIn"
                  >
                    {briefcase.loading ? (
                      <Loader />
                    ) : briefcase.error ? (
                      <ErrorMsg
                        title="¡Ups!"
                        msg={t("briefcase_modal_done_5")}
                      />
                    ) : (
                      <>
                        {hasBriefcases ? (
                          <div className="mb-2 mt-2">
                            <ScrollRangeBoard
                              target=".dx-datagrid-content"
                              title_scroll={t("briefcase_button_slide")}
                            />
                          </div>
                        ) : null}
                        <div className="d-flex ">
                          <p className="mb-2 mb-md-n4 mr-3">
                            {t("briefcase_title_numberbriefcase_1")}{" "}
                            <b className="text-primary">
                              {briefcases.length}{" "}
                              {t("briefcase_title_numberbriefcase_2")}
                            </b>{" "}
                            {t("briefcase_title_numberbriefcase_3")}
                          </p>
                        </div>
                        <div>
                          {hasBriefcases ? (
                            <SuperTableV2
                              data={briefcases}
                              columns={columns}
                              title_searchbox={t("briefcase_searchbox")}
                            />
                          ) : (
                            <div className="text-center pt-4 mt-4">
                              <img
                                src={emptyImg}
                                alt=""
                                className="img-fluid mb-3 animated pulse slower infinite"
                              />
                              <h5>{t("briefcase_nobriefcase_create")}</h5>
                              <p>{t("briefcase_nobriefcase_noyet")}</p>
                              <Button as={Link} to="/briefcase">
                                <i className="fa fa-plus-circle mr-2"></i>
                                {t("briefcase_nobriefcase_create")}
                              </Button>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </Layout>
      {!briefcase.error && !briefcase.loading ? (
        <Button
          as={Link}
          to="/briefcase"
          variant="success"
          className="position-fixed shadow animate__animated animate__fadeInUp animate__delay-2s"
          style={{ bottom: "1rem", right: "1rem" }}
        >
          <i className="fa fa-plus mr-2"></i>
          {t("briefcase_button_create")}
        </Button>
      ) : null}
    </>
  );
};

export default Briefcase;
